import type React from "react"
import { useState } from "react"
import { useHistory } from "react-router-dom"
import { Button, TextField, Alert, AlertTitle, Box } from "@mui/material"
import { CheckCircle } from "@mui/icons-material"
import FileUploader from "./FileUploader"
// import { submitDisciplinaryResponse } from "../../Services/disciplinaryService"
import styles from "./DisciplinaryResponseForm.module.css"
import { requestID } from "../../common/utils"
import { submitDisciplinaryResponse } from "../../api/disciplinaryService"

interface DisciplinaryResponseFormProps {
  caseId: string;
  disciplinaryId: string;
  employeeId: string;
  employeeName: string;
}

export default function DisciplinaryResponseForm({ caseId, disciplinaryId, employeeId, employeeName }: DisciplinaryResponseFormProps) {
  const history = useHistory()
  const [response, setResponse] = useState("")
  const [files, setFiles] = useState<File[]>([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async () => {
    

    if (!response.trim()) {
      setError("Please provide a response")
      return
    }

    setIsSubmitting(true)
    setError(null)

    try {
      const formData = new FormData()
      // formData.append("caseId", caseId)
      formData.append("response", response)
      formData.append("disciplinaryId", disciplinaryId)
      formData.append("requestID", requestID())

      files.forEach((file) => {
        formData.append("documents", file)
      })

      for (const [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`)
      }

      const res = await submitDisciplinaryResponse(formData)
      console.log({res})
      setSuccess(true)

      // Redirect after a short delay folder/my-disciplinary/View%20Disciplinary
      setTimeout(() => {
        history.push(`/folder/my-disciplinary/disciplinary`)
      }, 5000)
    } catch (err: any) {
      setError(err.message || "Failed to submit response")
    } finally {
      setIsSubmitting(false)
    }
  }

  if (success) {
    return (
      <Alert severity="success" icon={<CheckCircle fontSize="inherit" />}>
        <AlertTitle>Response Submitted</AlertTitle>
        Your response has been submitted successfully. The page will refresh shortly.
      </Alert>
    )
  }

  return (
    // <form onSubmit={handleSubmit} className={styles.form}>
    <>
      {error && (
        <Alert severity="error" className={styles.alert}>
          <AlertTitle>Error</AlertTitle>
          {error}
        </Alert>
      )}

      <div className={styles.formGroup}>
        <TextField
          id="response"
          label="Your Response"
          placeholder="Provide your detailed response to the disciplinary query..."
          multiline
          rows={8}
          fullWidth
          required
          value={response}
          onChange={(e) => setResponse(e.target.value)}
          variant="outlined"
        />
        <p className={styles.helperText}>
          Be clear, concise, and provide any relevant context or explanation. Your response will be reviewed by
          management.
        </p>
      </div>

      <div className={styles.formGroup}>
        <FileUploader
          onFilesChange={setFiles}
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
          maxSize={5}
          multiple={true}
          description="Upload any supporting documents that may help your case"
        />
      </div>

      <Box className={styles.buttonContainer}>
        <Button
          type="button"
          variant="outlined"
          onClick={() => history.push(`/disciplinary/${caseId}`)}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary" disabled={isSubmitting} onClick={handleSubmit}>
          {isSubmitting ? "Submitting..." : "Submit Response"}
        </Button>
      </Box>
      {/* </form> */}
    </>
  )
}
